<template>
  <div class="search-form">
    <div class="search-box-wrapper">
      <div class="search-item-wrapper">
        <p>{{ "โครงการ" }}</p>
        <el-select
          v-model="project"
          :filter-method="handleFilterProject"
          class="search-item"
          value-key="id"
          filterable
          clearable
          placeholder="เลือกโครงการ"
        >
          <el-option
            v-for="projectOption in projectOptions"
            :key="projectOption.id"
            :value="projectOption"
            :label="projectOption.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "บ้าน" }}</p>
        <el-select
          v-model="home"
          :placeholder="isSelectedProject ? 'เลือกบ้าน' : 'กรุณาเลือกโครงการ'"
          :disabled="!isSelectedProject"
          :filter-method="handleFilterHome"
          class="search-item"
          value-key="id"
          filterable
          clearable
        >
          <el-option
            v-for="homeOption in homeOptions"
            :key="homeOption.id"
            :value="homeOption"
            :label="homeOption.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "ชื่อลูกค้า" }}</p>
        <el-select
          v-model="user"
          :remote-method="searchUsers"
          :loading="loading"
          :placeholder="'ระบุชื่อลูกค้า'"
          class="search-item"
          value-key="id"
          filterable
          clearable
          remote
        >
          <el-option
            v-for="userOption in userResults"
            :key="userOption.id"
            :value="userOption"
            :label="userOption.label"
          ></el-option>
        </el-select>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "วันที่นัด" }}</p>
        <el-date-picker
          v-model="dateFrom"
          class="search-item"
          placeholder="เลือกวันที่นัด"
          format="dd MMMM yyyy"
          type="date"
        >
        </el-date-picker>
      </div>
      <div class="search-item-wrapper">
        <p>{{ "ถึง" }}</p>
        <el-date-picker
          v-model="dateTo"
          :placeholder="
            isSelectedDateFrom ? 'เลือกวันที่นัด' : 'กรุณาเลือกวันที่นัด'
          "
          :disabled="!isSelectedDateFrom"
          class="search-item"
          format="dd MMMM yyyy"
          type="date"
        >
        </el-date-picker>
      </div>
      <div v-if="isReportPage" class="search-item-wrapper">
        <p>{{ "สถานะงาน" }}</p>
        <el-select
          v-model="status"
          :placeholder="'เลือกสถานะ'"
          class="search-item"
          value-key="id"
          filterable
          clearable
        >
          <el-option
            v-for="statusOption in statusOptions"
            :key="statusOption.id"
            :value="statusOption"
            :label="statusOption.label"
        /></el-select>
      </div>
    </div>
    <div class="submit-button-wrapper">
      <button class="button reset-button ms-2" @click="handleResetSearch">
        <img src="/static/icons/supplier-close-icon.svg" />ยกเลิก
      </button>
      <button class="button search-button ms-2" @click="handleSearchSubmit">
        <img src="/static/icons/supplier-search-icon.svg" />ค้นหา
      </button>
    </div>
  </div>
</template>

<script>
import { DatePicker, Select, Option } from "element-ui"
import { baanRueJaiClient } from "@/dependencies"
import { DateTime } from "luxon"
import { mSize } from "../StaticVariable"
import { jsonToString, stringToJson } from "../../lib/jsonFormatter"
import { navigationMenu } from "../../lib/mapper"

export default {
  components: {
    "el-date-picker": DatePicker,
    "el-select": Select,
    "el-option": Option,
  },
  props: {
    projectResults: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const statusOptions = [
      {
        id: "ALL",
        label: "ทั้งหมด",
      },
      {
        id: "CREATED",
        label: "รอยืนยัน",
      },
      {
        id: "CONFIRMED",
        label: "ยืนยันแล้ว/รอดำเนินการ",
      },
      {
        id: "PROVIDER_FULFILLED",
        label: "ปิดงานแล้ว",
      },
    ]

    return {
      windowWidth: window.innerWidth,
      previousPath: null,
      dateFrom: null,
      dateTo: null,
      user: this.$route.query.user || null,
      userResults: [],
      project: null,
      projectQuery: "",
      home: null,
      homeResults: [],
      homeQuery: "",
      loading: false,
      statusOptions,
      status: statusOptions[0],
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= mSize
    },
    navigationMenu() {
      return this.$route.params.navigationMenu
    },
    isReportPage() {
      return this.navigationMenu === navigationMenu.REPORT
    },
    projectOptions() {
      if (!this.projectQuery) {
        return this.projectResults
      }

      return this.projectResults.filter((project) =>
        project.label.includes(this.projectQuery),
      )
    },
    isSelectedProject() {
      return this.project
    },
    isSelectedDateFrom() {
      return this.dateFrom
    },
    homeOptions() {
      if (!this.homeQuery) {
        return this.homeResults
      }

      return this.homeResults.filter((home) =>
        home.label.includes(this.homeQuery),
      )
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      this.checkRoutePath()
    },
    async project(newVal, oldVal) {
      if (!newVal) {
        this.projectQuery = null
        this.home = null
        return
      }

      if (!oldVal && newVal === oldVal) {
        return
      }

      if (oldVal && newVal) {
        this.home = null
      }
      this.setupHomes(newVal.id)
    },
    async home(value) {
      if (!value) {
        this.homeQuery = null
      }
    },
    async user(value) {
      if (!value) {
        this.userResults = []
      }
    },
    async status(value) {
      if (!value) {
        const [defaultStatus] = this.statusOptions
        this.status = defaultStatus
      }
    },
    async dateFrom(value) {
      if (!value) {
        this.dateTo = null
      }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupQuery()
    },
    setupQuery() {
      const { dateTime, project, home, status, user } = this.$route.query

      if (dateTime) {
        const dateTimeJSON = stringToJson(dateTime)

        this.dateFrom = DateTime.fromISO(dateTimeJSON.from).toJSDate()

        if (dateTimeJSON.hasDateTo) {
          this.dateTo = DateTime.fromISO(dateTimeJSON.to).toJSDate()
        }
      }

      if (project) {
        this.project = stringToJson(project)
      }

      if (home) {
        this.home = stringToJson(home)
      }

      if (this.isNotAllStatus(status)) {
        this.status = stringToJson(status)
      } else {
        this.status = undefined
      }

      if (user) {
        const userJSON = stringToJson(user)

        this.user = userJSON
        this.userResults = [userJSON]
      }
    },
    checkRoutePath() {
      if (
        this.previousPath === null ||
        this.$route.path !== this.previousPath
      ) {
        this.previousPath = this.$route.path
      }

      if (Object.keys(this.$route.query).length > 0) {
        return
      }

      this.clearSearch()
    },
    handleFilterProject(query) {
      this.projectQuery = query
    },
    async setupHomes(projectId) {
      const homes = await this.fetchHomes(projectId)

      this.homeResults = homes.map((home) => ({
        id: home.homeId,
        label: home.addressNo,
      }))
    },
    async fetchHomes(projectId) {
      const response =
        await baanRueJaiClient.others.supplier.getHomes(projectId)

      return response
    },
    handleFilterHome(query) {
      this.homeQuery = query
    },
    async searchUsers(query) {
      this.loading = true

      const [firstName, lastName, ...rest] = query.split(" ")
      const params = {
        firstName: firstName.trim(),
        lastName: lastName ? `${lastName} ${rest.join(" ")}`.trim() : undefined,
      }

      const result = await this.fetchUser(params)

      this.userResults = result.users.map((item) => {
        const user = item.user ? item.user : item

        return {
          id: user.user_id,
          label: `${user.user_profile.first_name} ${user.user_profile.last_name}`,
        }
      })

      this.loading = false
    },
    async fetchUser(query) {
      const response = await baanRueJaiClient.others.supplier.getUsers(query)

      return response
    },
    handleSearchSubmit() {
      let dateTime
      const from = DateTime.fromJSDate(this.dateFrom).toISO()
      if (this.dateFrom) {
        const to = DateTime.fromJSDate(this.dateTo || this.dateFrom)
          .endOf("day")
          .toISO()
        const hasDateTo = this.dateTo !== null

        dateTime = {
          from,
          to,
          hasDateTo,
        }
      }

      const query = {
        dateTime: dateTime ? jsonToString(dateTime) : undefined,
        project: this.project ? jsonToString(this.project) : undefined,
        home: this.home ? jsonToString(this.home) : undefined,
        status: this.isNotAllStatus(this.status)
          ? jsonToString(this.status)
          : undefined,
        user: this.user ? jsonToString(this.user) : undefined,
      }

      this.$emit("searchSubmit", query)
    },
    clearSearch() {
      this.dateFrom = null
      this.dateTo = null
      this.project = null
      this.home = null
      const [defaultStatus] = this.statusOptions
      this.status = defaultStatus
      this.user = null
      this.userResults = []
    },
    handleResetSearch() {
      this.clearSearch()

      this.$emit("searchSubmit", "")
    },
    isNotAllStatus(status) {
      return status && status.id !== "ALL"
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.search-form {
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: auto;
}

.search-box-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 16px;
  padding: 24px;
}

.search-item-wrapper {
  display: flex;
  flex-direction: column;

  p {
    font-size: $font-14;
  }
}

.search-item {
  width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.submit-button-wrapper {
  margin-inline: 24px;
  margin-bottom: 24px;
  text-align: right;

  .button {
    padding-inline: 12px;
    height: 40px;
    font-weight: bold;
    font-size: $font-16;
    border-radius: 8px;
    align-items: center;

    img {
      margin-right: 8px;
    }
  }

  .search-button {
    background: transparent;
    border: 1px solid $supplier-primary-color;
    color: $supplier-primary-color;

    &:hover:not(:disabled) {
      background: $color-light-gray-1-hover;
    }
  }

  .reset-button {
    color: $black;
    background: transparent;
    border: 1px solid $color-light-gray-1;

    &:hover:not(:disabled) {
      background: $color-light-gray-1-hover;
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 16px;
  }

  .submit-button-wrapper {
    display: flex;
    flex-direction: row;
    margin-inline: 16px;
    margin-block: 16px;

    .button {
      width: 50%;
      padding-inline: 16px;
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 24px;
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .search-box-wrapper {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 24px;
  }
}
</style>
